import { type FunctionComponent } from 'react';
import { useClientOnlyBreakpoints } from '../../../../hooks/breakpoints/client-only-breakpoints.hook';
import { type ShopByLookContent } from '../../../../types/construct.types';
import { HomeShopByLookLarge } from './shop-by-look-large.component';
import { HomeShopByLookSmall } from './shop-by-look-small.component';

const NEW_SHOP_BY_LOOK_STYLES = 'flex flex-row flex-wrap flex-nowrap-l bg-theme-primary-dark w-100 h-100';

export type HomeShopByLookProps = {
	content: ShopByLookContent;
	className?: string;
};

export const HomeShopByLook: FunctionComponent<HomeShopByLookProps> = ({
	content,
	className = 'flex flex-column items-center w-100 h-100'
}) => {
	const { isLarge } = useClientOnlyBreakpoints();
	const slides = content.fields.slides.items;

	return (
		<section className={className}>
			{isLarge ? (
				<HomeShopByLookLarge className={NEW_SHOP_BY_LOOK_STYLES} slides={slides} />
			) : (
				<HomeShopByLookSmall className={NEW_SHOP_BY_LOOK_STYLES} slides={slides} />
			)}
		</section>
	);
};
